<template>
  <div class="interpretation__card">
    <div class="header">
      Interpretation
    </div>
    <div class="subheader">
      RETV characterizes the thermal performance of the building envelope (except roof)
    </div>
    <div class="card__content">
      <div class="retv__formula">
        <div class="formula-wrap">
          <div>
            𝑹𝑬𝑻𝑽 (𝑾/𝒎<span><sup>2</sup></span> )
          </div>
          <div style="margin:6px">=</div>
          <div>
            <span>𝑵𝒆𝒕 𝒉𝒆𝒂𝒕 𝒈𝒂𝒊𝒏 𝒓𝒂𝒕𝒆 𝒕𝒉𝒓𝒐𝒖𝒈𝒉 𝒃𝒖𝒊𝒍𝒅𝒊𝒏𝒈 𝒆𝒏𝒗𝒆𝒍𝒐𝒑𝒆 </span>
            <hr />
            <span>𝑨𝒓𝒆𝒂 𝒐𝒇 𝒃𝒖𝒊𝒍𝒅𝒊𝒏𝒈 𝒆𝒏𝒗𝒆𝒍𝒐𝒑𝒆</span>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="card__info">
        <div>
          <strong><u>TERM 1:</u> </strong> Heat conduction through opaque building envelope components.
        </div>
        <div>
          <strong><u>TERM 2:</u> </strong> Heat conduction through non-opaque building envelope components.
        </div>
        <div>
          <strong><u>TERM 3:</u> </strong> Solar radiation through non-opaque building envelope components.
        </div>
        <div class="card__note">
          <i>
            *Limiting the RETV value helps in reducing heat gains from the building envelope
          </i>
        </div>
        <div>
          Opaque components: wall, opaque panels in doors, windows, ventilators, etc. <br />
          Non opaque: transparent/translucent panels of windows, doors, ventilators, etc.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.interpretation__card {
  padding: 12px 28px 12px 28px;
  background-color: #e5f3fe;
  border-radius: 8px;
  color: #2a9bf5;
  .header {
    text-align: center;
    font-weight: 500;
  }
  .subheader {
    text-align: center;
    font-size: 13px;
  }
  .card__content {
    display: flex;
    flex-direction: column;
    // align-items: center;
    // justify-content: center;
  }
  .retv__formula {
    text-align: center;
    padding: 12px;
  }
  .formula-wrap {
    display: flex;
    font-size: 14px;
    justify-content: center;
    align-items: center;
  }
  .card__info {
    font-size: 13px;
  }
  .card__note {
    color: teal;
    font-size: 12px;
    padding: 4px;
  }
}
</style>
